import { Formik, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { valListAction } from "../../redux/actions/general-action";
import {
  productInventoryAction,
  productPackingAction,
} from "../../redux/actions/product-action";
import AddButton from "../buttons/button";
import CheckBox from "../forms/check-box-field";
import InputField from "../forms/input-field";
import SelectField from "../forms/select-field";
import errorToast from "../helper-components/error-toast";
import successToast from "../helper-components/success-toast";

const PackingTab = ({
  page,
  packingData,
  packingTypeData,
  cartonData,
  packData,
  productId,
  uomList,
  setFormValues,
  formValues,
  setCurrentTab,
  product,
  disabled = false,
  itemGeneralData = {},
  hasUnsavedChanges,
  setHasUnsavedChanges,
  isFormSaved,
  setIsFormSaved,
  onTabChange,
  onPackingDataChange,
}) => {
  const dispatch = useDispatch();
  const [valList, setvalList] = useState([]);

  // Debug: Log the props received
  console.log("=== PACKING TAB PROPS ===");
  console.log("hasUnsavedChanges:", hasUnsavedChanges);
  console.log("isFormSaved:", isFormSaved);
  console.log("setHasUnsavedChanges:", typeof setHasUnsavedChanges);
  console.log("setIsFormSaved:", typeof setIsFormSaved);

  const [primaryValue, setPrimaryValue] = useState("");
  const [primarySelected, setPrimarySelected] = useState("");

  const [secondaryValue, setSecondaryValue] = useState("");
  const [tertiaryValue, setTertiaryValue] = useState("");
  const [primaryID, setPrimaryID] = useState("");
  const [secondaryID, setSecondaryID] = useState("");
  const [tertiaryID, setTertiaryID] = useState("");

  // Packing tab specific state for navigation blocking
  const [packingHasUnsavedChanges, setPackingHasUnsavedChanges] =
    useState(false);
  const [packingIsFormSaved, setPackingIsFormSaved] = useState(false);
  useEffect(() => {
    dispatch(valListAction(onvalSuccess, onvalError));
  }, []);
  // const { values } = useFormikContext();
  const onvalSuccess = (data) => {
    setvalList(
      data?.data?.scheduleList?.map((item) => {
        return { label: item?.valuationMethod, value: item?.valuationMethod };
      })
    );
  };
  const onvalError = (data) => {
    errorToast(data?.message);
  };
  console.log(
    "::::::::::::::::::::::",
    packingData,
    packingTypeData,
    cartonData
  );
  const initialValues = {
    packing: product?.packing ?? "",
    packing_type: product?.packing_type ?? "",
    carton: product?.carton ?? "",
    item_id: product?.item_id ?? "",
    item_packing_type: product?.item_packing_type ?? "",
    item_packing: product?.item_packing ?? "",
    item_carton_type: product?.item_carton_type ?? "",
    item_primary_pack_size: product?.item_primary_pack_size ?? "",
    item_secondary_pack_size: product?.item_secondary_pack_size ?? "",
    item_tertiary_pack_size: product?.item_tertiary_pack_size ?? "",
    item_baby_box_packing: product?.item_baby_box_packing ?? "",
  };

  const validationSchema = Yup.object().shape({
    // item_packing_type: Yup.string().required("required"),
    // item_packing: Yup.string().required("required"),
    // item_carton_type: Yup.string().required("required"),
  });

  // Compute the "baby box packing" string from the selected pack sizes/type
  const computeBabyBoxPacking = () =>
    `${secondaryValue || ""}${secondaryValue &&
      secondaryValue !== "" &&
      secondaryValue !== null &&
      secondaryValue !== undefined &&
      ((primaryValue &&
        primaryValue !== "" &&
        primaryValue !== null &&
        primaryValue !== undefined) ||
        (primarySelected &&
          primarySelected !== "" &&
          primarySelected !== null &&
          primarySelected !== undefined))
      ? " * "
      : ""
      }${primaryValue || ""}${primaryValue &&
      primaryValue !== "" &&
      primaryValue !== null &&
      primaryValue !== undefined &&
      primarySelected &&
      primarySelected !== "" &&
      primarySelected !== null &&
      primarySelected !== undefined
      ? " * "
      : ""
      }${primarySelected || ""}`;

  // Build the packing payload sent to the backend (used both by the packing
  // save and when the packing details are sent along with the general update)
  const buildPackingPayload = (values) => ({
    item_id: productId ?? "",
    item_packing_type: values?.item_packing_type ?? "",
    item_packing: values?.item_packing ?? "",
    item_carton_type: values?.item_carton_type ?? "",
    item_primary_pack_size: primaryID,
    item_secondary_pack_size: secondaryID,
    item_tertiary_pack_size: tertiaryID,
    item_baby_box_packing: computeBabyBoxPacking(),
  });

  // Packing tab change tracker and navigation blocking
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      // Don't track changes if form was just saved
      if (packingIsFormSaved) {
        setPackingHasUnsavedChanges(false);
        if (onTabChange) {
          onTabChange(false);
        }
        return;
      }

      // Compare with initial values
      const hasChanges =
        JSON.stringify(initialValues) !== JSON.stringify(values);
      setPackingHasUnsavedChanges(hasChanges);

      // Notify parent component about changes
      if (onTabChange) {
        onTabChange(hasChanges);
      }

      console.log("=== PACKING TAB CHANGE TRACKER ===");
      console.log("Packing has changes:", hasChanges);
      console.log("Initial values:", initialValues);
      console.log("Current values:", values);
    }, [values, packingIsFormSaved, onTabChange]);

    // Keep the parent's copy of the packing payload in sync so it can be sent
    // along with the general details update.
    useEffect(() => {
      if (onPackingDataChange) {
        onPackingDataChange(buildPackingPayload(values));
      }
    }, [
      values,
      primaryID,
      secondaryID,
      tertiaryID,
      primaryValue,
      secondaryValue,
      primarySelected,
    ]);

    // Navigation blocking is now handled by parent component (EditProduct)

    return null;
  };

  const innerOnSubmit = (values, { setSubmitting, setErrors }) => {
    console.log("=== PACKING TAB SUBMIT DEBUG ===");
    console.log("initialValues:", initialValues);
    console.log("current values:", values);
    console.log(
      "Are they equal?",
      JSON.stringify(initialValues) === JSON.stringify(values)
    );

    // Validate the form
    if (JSON.stringify(initialValues) === JSON.stringify(values)) {
      console.log("No changes detected - showing error toast");
      return errorToast("No changes");
    }

    console.log("Changes detected - proceeding with API call");

    // Reset unsaved changes after successful submission (only if functions exist)
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(false);
    }
    if (setIsFormSaved) {
      setIsFormSaved(true);
    }

    // console.log("22222222222222222222", !productId);
    // if (!productId) return errorToast("Create general first");

    validationSchema
      .validate(values, { abortEarly: false })
      .then(() => {
        setFormValues({
          ...formValues,
          packData: values,
        });
        dispatch(
          productPackingAction(
            {
              itemGeneralData: itemGeneralData,
              itemPackingData: buildPackingPayload(values),
            },
            onSuccess,
            onError
          )
        );
        setHasUnsavedChanges(false);
        setIsFormSaved(true);
        setPackingHasUnsavedChanges(false);
        setPackingIsFormSaved(true);
        setSubmitting(false);
      })
      .catch((err) => {
        console.log("=== VALIDATION ERROR ===");
        console.log("Error object:", err);
        console.log("err.inner:", err.inner);

        const errors = {};
        if (err.inner && Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            errors[error.path] = error.message;
          });

          // Display validation errors as error toast
          const errorMessages = err.inner
            .map((error) => error.message)
            .join(", ");
          errorToast(` ${errorMessages}`);
        } else {
          // Handle case where err.inner is undefined or not an array
          console.log(
            "err.inner is undefined or not an array, using fallback error handling"
          );
        }

        setErrors(errors);
        setSubmitting(false);
      });
  };

  const onSuccess = (data) => {
    console.log("=== PACKING TAB SUCCESS ===");
    console.log("Success data:", data);
    successToast(data?.message);
    setCurrentTab("Purchasing");
  };
  const onError = (data) => {
    console.log("=== PACKING TAB ERROR ===");
    console.log("Error data:", data);
    errorToast(
      data?.message || "An error occurred while saving packing information"
    );
  };

  useEffect(() => {
    if (packingTypeData?.length > 0) {
      const matchedItem = packingTypeData.find(
        (item) => item.value === product?.item_packing_type
      );
      if (matchedItem) {
        setPrimarySelected(matchedItem.label);
      }
    }
  }, [packingTypeData, product]);
  useEffect(() => {
    setPrimaryValue(packData.primary);
    setSecondaryValue(packData.secondary);
    setTertiaryValue(packData.tertiary);
    setPrimaryID(packData.primaryID);
    setSecondaryID(packData.secondaryID);
    setTertiaryID(packData.tertiaryID);
  }, [packData]);

  console.log("packData", packData, packData.primary);
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={formValues?.inventory ?? initialValues}
        // validationSchema={validationSchema}
        onSubmit={innerOnSubmit}
      >
        {({ values, handleSubmit, errors }) => {
          return (
            // <Form>
            <>
              <FormChangeTracker />
              <div className="flex flex-wrap mt-3">
                <div className="w-full 2xl:w-[30%] lg:w-1/2 px-5 xl:px-10">
                  <SelectField
                    handleSelected={(data) => {
                      setPrimarySelected(data.label);
                    }}
                    isDisabled={disabled}
                    placeholder="Select Packing Type"
                    options={packingTypeData}
                    label="Packing Type"
                    id="item_packing_type"
                    name="item_packing_type"
                    isSearchable={true}
                    errMsgContainerClass="ps-2"
                    // isRequired={true}
                    labelWidth="9rem"
                  />

                  <label className="py-1 whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]">
                    Primary Pack Size : {primaryValue}
                  </label>
                </div>
                <div className="w-full 2xl:w-[30%] lg:w-1/2 px-5 xl:px-10">
                  <SelectField
                    isDisabled={disabled}
                    placeholder="Select Packing"
                    options={packingData}
                    label="Packing"
                    id="item_packing"
                    name="item_packing"
                    isSearchable={true}
                    errMsgContainerClass="ps-2"
                    // isRequired={true}
                    labelWidth="9rem"
                  />

                  <label className="py-1 whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]">
                    Secondary Pack Size : {secondaryValue}
                  </label>
                </div>
                <div className="w-full 2xl:w-[30%] lg:w-1/2 px-5 xl:px-10">
                  <SelectField
                    isDisabled={disabled}
                    placeholder="Select Carton Type"
                    options={cartonData}
                    label="Carton type"
                    id="item_carton_type"
                    name="item_carton_type"
                    isSearchable={true}
                    errMsgContainerClass="ps-2"
                    // isRequired={true}
                    labelWidth="9rem"
                  />

                  <label className="py-1 whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]">
                    Tertiary Pack Size : {tertiaryValue}
                  </label>
                </div>
              </div>
              <div className="pt-5">
                <label className=" px-10 py-3 whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]">
                  Baby Box Packing: {computeBabyBoxPacking()}
                </label>
              </div>
              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={handleSubmit}
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                  />
                </div>
              )}
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default PackingTab;
